<template>
  <div class="img">
    <img
        :class="['AI']"
        src="@/assets/images/glm/robotLeft.png"
        alt=""
        v-if="flag"
        @click.stop="AskFun"
    />
    <!-- src="@/assets/images/glm/AllPointMeToAsk.png" -->
    <!-- <button class="AskButton" @click.stop="AskFun" v-if="flag"></button> -->
    <div class="askBox" v-else-if="flag == false">
      <header class="head">
        <div class="name">
          {{ typeData[index].label }}
          <i
            :class="[
              selected
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down',
            ]"
            @click="change"
            style="padding:0 2px;font-size:12px;"
          ></i>
        </div>
        <!-- <div class="name_text" v-show="!selected">
            基于GLM的虚拟人已唤醒,可以随时问问题了!
        </div> -->
        <i class="el-icon-close chose" @click="chose"></i>
      </header>
      <div class="chat-content" ref="charContent">
        <div
          class="name_text"
          v-show="!selected"
          style="font-size:12px;text-align:center;color: #939393;"
        >
          基于GLM的虚拟人已唤醒,可以随时问问题了!
        </div>
        <div v-for="(itemc, indexc) in recordContent" :key="indexc">
            <!-- 对方 -->
            <div :class="['word']" v-if="!itemc.isSelf">
              <img :src="itemc.headUrl" />
              <div class="info">
                <p class="time" style="font-size:12px;">
                    {{ typeData[index].label }}
                </p>
                <div class="info-content">
                    {{ itemc.contactText }}
                </div>
                <div class="message_time">
                    {{ itemc.time }}
                </div>
              </div>
            </div>
            <!-- 我的 -->
            <div :class="['word-my']" v-else>
              <div class="info">
                <p class="time" style="font-size:12px;margin-right:15px;">
                  我
                </p>
                <div class="info-content">
                  {{ itemc.contactText }}
                </div>
                <div class="Sender_time">
                  {{ itemc.Sender }}
                </div>
              </div>
              <!-- <img v-if="userInfo.headIcon" :src="define.comUrl + userInfo.headIcon" /> -->
              <!-- <img :src="itemc.headUrl" onerror="normal"/> -->
              <el-image :src="itemc.headUrl" class="img">
                <div slot="error" class="image-slot">
                  <img :src="normal"/>
                </div>
              </el-image>
            </div>
        </div>
      </div>
      <footer class="foot">
        <!-- <div
            class="textarea"
            ref="textArea"
            :contenteditable="true"
            @blur="test"
        ></div> -->
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="textarea"
          @blur="test"
          class="textArea"
          auto="true"
          rows="3"
          @keydown.enter.native="textareaKeydown"
        >
        </el-input>
        <el-button
          class="send"
          @click="send"
          @keyup.enter.native="enterLogin()"
          >发送</el-button>
        <el-button
          v-if="!isRecording&&!isPlaying"
          class="start-record"
          @click="startRecord"
        >开始录音</el-button>
        <el-button
          v-if="isRecording&&!isPlaying"
          class="stop-record"
          @click="stopRecord"
        >结束录音</el-button>
      </footer>
      <div class="mark" v-if="selected" @click="maskFun">
        <div class="headerBox">
          <div class="text">点击切换聊天对象</div>
          <div class="itemBox">
            <div
              :class="['box', index === indexc ? 'on' : '']"
              v-for="(item, indexc) in typeData"
              :key="indexc"
              @click="typeChange(indexc)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import { Message } from 'element-ui'

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

const connection_id = S4();

export default {
    data() {
        let img = require('@/assets/images/glm/glmAvatar.png')
        let normal = require('@/assets/images/glm/normal.png')
        return {
            recorder: null,
            isRecording: false,
            startDisabled: false,
            stopDisabled: false,
            recordContent: [],
            flag: false,
            selected: false,
            isPlaying: false,
            typeData: [
                { label: '智小鑫', id: 'all' },
                { label: '充换电业务', id: 'chonghuandian' },
                { label: '系统功能问答', id: 'gongnengqingdan' },
                // { label: '协鑫大学', id: 'xiexindaxue' },
                // { label: '入职须知', id: 'ruzhixuzhi' },
                // { label: '职务助理', id: 'zhiwuzhuli' },
            ],
            index: 0,
            model: {
              validate: 'f4bde2a342c7c75aa276f78b26cfbd8a',
              type: '',
              uuid: 'chatbe409b15-cd1b-7f8b-329a-265b58a4c229',
              knowledge_base_id: '',
              query: '',
              session_id: connection_id,
              voice: null // type为voice时,此字段为要上传的voice的二进制数据
              ,app_type: 'ue'
            },
            textarea: '',
            textFlag: true,
            Avatar: img,
            createTime: '',
            normal: normal,
        }
    },
    created() {
      this.enterLogin();
      this.handleWS();
    },
    mounted() {
      console.log('Recorder:',new Recorder())
      this.initRecorder();
    },
    computed: {
        ...mapGetters(['userInfo']),
    },
    methods: {
      initRecorder(){
        this.recorder = new Recorder({
          monitorGain: 0,
          recordingGain: 1,
          numberOfChannels: 1,
          wavBitDepth: 16,
          encoderPath: "./static/waveWorker.min.js"
        });
        this.isRecording = false;
      },
      startRecord(){
        console.log('startRecord--- --- ---');
        // debugger
        if (this.isRecording) return;
        this.isRecording = true;
        let that = this;
        if (!Recorder.isRecordingSupported()) {
          // toastr.error("您的浏览器不支持录音", '录音失败');
          Message({
            message: '您的浏览器不支持录音,录音失败!',
            type: 'error'
          });
          return;
        }
        const recorder = this.recorder;
        console.log('recorder:',recorder);
        recorder.start().catch(function(e){
          // toastr.error(e.message, '录音失败');
          Message({
            message: e.message,
            type: 'error'
          });
        });

        recorder.onstart = function(){
          console.debug('Recorder is started');
          that.startDisabled = true;
          that.stopDisabled = false;
        };

        recorder.onstop = function(){
          console.debug('Recorder is stopped');
          that.startDisabled = false;
          that.stopDisabled = true;
        };

        recorder.onstreamerror = function(e){
          console.error('Error encountered: ' + e.message );
        };

        recorder.ondataavailable = function( typedArray ){
          // debugger
          console.log('recorder.ondataavailable --- --- ---');
          const data = arrayBufferToBase64(typedArray);
          console.log('data:',data);

          that.model.type = 'voice';
          that.model.knowledge_base_id = that.typeData[that.index].id;
          that.model.voice = data;
          axios.post('https://robotpre.gclme.com/connect/chat_conn/',that.model)
        };

        function arrayBufferToBase64( buffer ) {
          var binary = '';
          var bytes = new Uint8Array( buffer );
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode( bytes[ i ] );
          }
          return window.btoa( binary );
        }
      },
      stopRecord(){
        console.log('stopRecord--- --- ---');
        if (!this.isRecording) return;
        this.isRecording = false;
        this.recorder.stop();
      },
      handleWS(){
        let that = this;
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const audioTasks = []; // 存储音频任务的队列
        let isPlaying = false;

        function playNextAudio() {
          if (audioTasks.length > 0 && !isPlaying) {
            // 对音频任务数组按时间戳升序排序
            audioTasks.sort((a, b) => a.timestamp - b.timestamp);

            const nextAudioTask = audioTasks.shift(); // 获取时间戳最小的音频任务
            isPlaying = true;

            const source = nextAudioTask.source;
            source.onended = () => {
              console.log('source.onended--- --- ---');
              isPlaying = false;
              playNextAudio(); // 当前音频播放完毕后播放下一个音频
            };

            // 启动音频上下文并播放
            audioContext.resume().then(() => {
              console.log('source.start--- --- ---');
              source.start();
            }).catch((error) => {
              console.error("Error resuming audio context:", error);
            });
          }
          else if(audioTasks.length === 0 && !isPlaying){
            //播放完毕
            console.log('播放完毕--- --- ---');
            that.$emit('isPlaying', false)
            that.isPlaying = false;
          }
        }

        const wss = new WebSocket(`wss://robotpre.gclme.com/ue_websocket?connection_id=${connection_id}`);
        wss.onopen = () => {
          wss.send('wss onopen');
        }
        //接听服务器发回的信息并处理展示
        wss.onmessage = (e) => {
          console.log('wss.onmessage e:',e);
          var message = e.data;

          // 判断是否为心跳包
          if (message === "pong") {
            // 收到心跳包，不做任何处理
            return;
          }
          // 解析其他消息
          var data = JSON.parse(message);
          if (data.action === "new_message_ue") {
            console.log("收到新message: ", data);
            // showMessage(data)

            const found = this.recordContent.find(item=>item.id===data.uuid);
            if(!!found){
              found.contactText += data['text'];
            }
            else {
              this.recordContent.push({
                id: data.uuid,
                contactText: data['text'],
                time: this.getTime(),
                headUrl: this.Avatar,
              });
            }

            this.scrollTo()
          }
          else if(data.action === "new_audio_ue"){
            console.log("收到新audio: ", data);

            const audioFilePath = `${data['text']}`;
            console.log(`已接收音频文件：${audioFilePath}`);

            // 创建音频源节点
            const source = audioContext.createBufferSource();
            // 获取时间戳并添加到音频数据中
            const timestamp = Date.now();
            source.timestamp = timestamp;

            fetch(audioFilePath)
                .then((response) => response.arrayBuffer())
                .then((audioData) => {
                  return audioContext.decodeAudioData(audioData);
                })
                .then((buffer) => {
                  source.buffer = buffer;

                  // 创建音量节点并设置音量
                  const gainNode = audioContext.createGain();
                  gainNode.gain.value = 1;

                  // 连接音频节点
                  source.connect(gainNode);
                  gainNode.connect(audioContext.destination);

                  // // 获取时间戳并添加到音频数据中
                  // const timestamp = Date.now();
                  // source.timestamp = timestamp;

                  // 存储音频任务，包括时间戳和源节点
                  audioTasks.push({timestamp, source});

                  // 如果没有正在播放的音频，开始播放队列中的下一个音频
                  if (!isPlaying) {
                    this.$emit('isPlaying', true)
                    this.isPlaying = true;
                    playNextAudio();
                  }
                })
                .catch((error) => {
                  console.error("Error loading audio:", error);
                });
          }
          else if(data.action === "new_speech_query"){
            console.log("收到语音识别内容: ", data);
            this.recordContent.push({
              isSelf: true,
              contactText: data['text'],
              time: this.getTime(),
              headUrl: this.Avatar,
            });
          }
        }
        //监听连接关闭事件
        wss.onclose = (err) => {
          console.log('wss.onclose err:',err)
          this.handleWS();
        }
        //监听并处理error事件
        wss.onerror = function(err) {
          console.log('wss.onerror error:',err)
        }
      },
      AskFun() {
          // console.log('ask')
          this.flag = false
          this.$emit('animation', true)
      },
      chose() {
          this.flag = true
          this.recordContent = []
          this.selected = false
          this.$emit('animation', false)
      },
      async send() {
          let str = this.trim(this.textarea)
          console.log(str.length, 'str')
          if (str.length == 0) return
          if (this.textarea == '') {
              this.$message({
                  message: '请输入内容!',
                  type: 'warning',
              })
              return
          } else if (str.indexOf(' ') != -1) {
              this.$message({
                  message: '请输入正确的问题!',
                  type: 'warning',
              })
              return
          } else if (str.match(/^[ ]*$/)) {
              this.$message({
                  message: '请输入正确的问题!',
                  type: 'warning',
              })
              return
          }
          this.model.type = 'text'
          this.model.knowledge_base_id = this.typeData[this.index].id
          this.model.query = this.textarea
          this.recordContent.push({
              isSelf: true,
              contactText: this.textarea,
              Sender: this.getTime(),
              // headUrl: this.define.comUrl + this.userInfo.headIcon,
          })
          this.scrollTo()
          this.textarea = ''
          axios.post('https://robotpre.gclme.com/connect/chat_conn/',this.model)

      },
      change() {
          this.selected = !this.selected
      },
      typeChange(index) {
          this.index = index
          this.selected = !this.selected
      },
      // 接受消息后自动向下移动
      scrollTo() {
          this.$nextTick(() => {
              let scrollElem = this.$refs.charContent // 对应ref的命名
              scrollElem.scrollTo({
                  top: scrollElem.scrollHeight,
                  behavior: 'smooth',
              })
          })
      },
      // 点击阴影部分收起下拉框
      maskFun() {
          this.selected = !this.selected
      },
      enterLogin() {
          document.onkeydown = e => {
              // console.log(e, 'enter')
              e = window.event || e
              if (e.code == 'Enter' || e.code == 'enter') {
                  this.send()
                  // this.$refs.textArea.innerText = ''
                  this.test()
              }
          }
      },
      test() {
          // console.log('失去焦点')
      },
      textareaKeydown() {
          let e = window.event || arguments[0]
          // console.log(e,e.keyCode)
          if (e.key == 'Enter' || e.code == 'Enter' || e.keyCode == 13) {
              e.returnValue = false
              return false
          }
      },
      getTime() {
          //获取年份
          var year = new Date().getFullYear()
          //获取月
          var month = new Date().getMonth() + 1
          //获取日
          var date = new Date().getDate()
          if (date < 10) {
              date = '0' + date
          } //如果只有个位数显示两位数
          // 获取小时
          var hours = new Date().getHours()
          if (hours < 10) {
              hours = '0' + hours
          } //如果只有个位数显示两位数
          // 获取分钟
          var minutes = new Date().getMinutes()
          if (minutes < 10) {
              minutes = '0' + minutes
          } //如果只有个位数显示两位数
          // 获取秒
          var seconds = new Date().getSeconds()
          if (seconds < 10) {
              seconds = '0' + seconds
          } //如果只有个位数显示两位数
          var createTime =
              // year +
              // '年' +
              // month +
              // '月' +
              // date +
              // '日 ' +
              hours + ':' + minutes + ':' + seconds
          this.createTime = createTime
          console.log(createTime)
          return this.createTime
      },
      trim(str) {
          str = str.replace(/^(\s|\u00A0)+/, '')
          console.log(11)
          for (var i = str.length - 1; i >= 0; i--) {
              if (/\S/.test(str.charAt(i))) {
                  str = str.substring(0, i + 1)
                  break
              }
          }
          console.log(str)
          return str
      },
      errorHandler() {
          return true
      },
    },
}
</script>

<style lang="scss" scoped>
.AI {
    position: relative;
    width: 30px;
    height: auto;
}
.AskButton {
    width: 90%;
    height: 30px;
    position: absolute;
    top: 92px;
    left: 6px;
    border: 0;
    background: none;
    // background: red;
}
::-webkit-scrollbar {
    display: none;
}
.askBox {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    // flex: 1;
    background: white;
    border-radius: 20px;
    border: 1px solid #eee;
    overflow: auto;
    .head {
        width: 100%;
        height: 60px;
        text-align: center;
        position: absolute;
        top: 0%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #ffffff;
        z-index: 120;
        border: 1px solid #eee;
        border-bottom: 0;
        border-radius: 20px 20px 0 0;
        .name {
            margin: 20px 0;
        }
        .name_text {
            margin-top: -10px;
            font-size: 12px;
            color: #939393;
        }
        .chose {
            position: absolute;
            top: 13px;
            right: 13px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            color: white;
            background: #ccc;
            text-align: center;
            line-height: 20px;
        }
    }
    .foot {
        position: absolute;
        bottom: 5px;
        width: 99.5%;
        height: 98px;
        border-top: 1px solid #eee;
        border-radius: 0px 0px 20px 20px;
        background: white;
        .textarea {
            margin: 2px 4px;
            width: 98.5%;
            height: 100%;
            margin: auto;
        }
        .el-input {
            width: 100%;
            height: 100%;
            border: 0;
        }
        .send {
            position: absolute;
            right: 20px;
            bottom: 20px;
            border-radius: 5px;
        }
        .start-record,.stop-record {
          position: absolute;
          left: 20px;
          bottom: 20px;
          border-radius: 5px;
        }
    }
    .foot >>> .el-textarea__inner {
        border: 0;
        resize: none; /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
    }
    .mark {
        position: absolute;
        top: 0;
        background: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 100%;
        border-radius: 0px 0px 20px 20px;
        .headerBox {
            padding-top: 45px;
            width: 100%;
            height: 120px;
            background: #f0f0f0;
            display: flex;
            flex-direction: column;
            // align-items: center;
            .text {
                padding-left: 20px;
                font-size: 14px;
                padding-bottom: 5px;
                color: #424242;
            }
            .itemBox {
                padding-top: 5px;
                // padding-left: 13px;
                display: flex;
                flex-wrap: wrap;
                .box {
                    margin: 5px 20px;
                    padding: 3px 10px;
                    border-radius: 20px;
                    background: white;
                    font-size: 14px;
                }
                .box:hover {
                    cursor: pointer;
                }
                .on {
                    color: #c62828;
                }
            }
        }
    }
}

.el-image {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
.chat-content {
    position: relative;
    margin-top: 10px;
    padding: 20px;
    height: 300px;
    //   background: darkorange;
    overflow: auto;
    .word {
        display: flex;
        margin-bottom: 10px;

        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
        .info {
            width: 47%;
            margin-left: 10px;
            .message_time {
                font-size: 12px;
                color: rgba(51, 51, 51, 0.8);
                margin: 0;
                height: 20px;
                line-height: 20px;
                margin-top: -5px;
                margin-top: 5px;
            }
            .info-content {
                word-break: break-all;
                // max-width: 45%;
                display: inline-block;
                padding: 10px;
                font-size: 14px;
                background: #fff;
                position: relative;
                margin-top: 8px;
                background: #f0f0f0;
                border-radius: 4px;
            }
            //小三角形
            .info-content::before {
                position: absolute;
                left: -8px;
                top: 8px;
                content: '';
                border-right: 10px solid #f0f0f0;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
            }
        }
    }

    .word-my {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;
        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
        .info {
            width: 90%;
            // margin-left: 10px;
            text-align: right;
            // position: relative;
            display: flex;
            align-items: flex-end;
            flex-wrap: wrap;
            flex-direction: column;
            .info-content {
                word-break: break-all;
                max-width: 45%;
                padding: 10px;
                font-size: 14px;
                // float: right;
                margin-right: 10px;
                position: relative;
                margin-top: 8px;
                background: #f0f0f0;
                text-align: left;
                border-radius: 4px;
            }
            .Sender_time {
                padding-right: 12px;
                padding-top: 5px;
                font-size: 12px;
                color: rgba(51, 51, 51, 0.8);
                margin: 0;
                height: 20px;
            }
            //小三角形
            .info-content::after {
                position: absolute;
                right: -8px;
                top: 8px;
                content: '';
                border-left: 10px solid #f0f0f0;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
            }
        }
    }
}

//     .foot::v-deep.el-input__inner {
//     border: 0;
//   }
/* 如果你的 el-input type 设置成textarea ，就要用这个了 */
.foot {
    ::v-deep.el-textarea__inner {
        border: 0;
        resize: none; /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
    }
}
</style>
